import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet'
import 'leaflet/dist/leaflet.css'
import L from 'leaflet'
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png'
import markerIcon from 'leaflet/dist/images/marker-icon.png'
import markerShadow from 'leaflet/dist/images/marker-shadow.png'

// Configurar el ícono del marcador
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
})

const Mapa = ({ onLocationSelect, pos }) => {
  const [position, setPosition] = useState(pos ?? { lat: 0, lng: 0 })

  const LocationMarker = () => {
    useMapEvents({
      click(e) {
        setPosition(e.latlng)
        onLocationSelect(e.latlng)
      },
    })

    return position === null ? null : <Marker position={position}></Marker>
  }

  useEffect(() => {
    if (pos != undefined) setPosition(pos)
  }, [pos])

  return (
    <MapContainer center={[-32.2, -59.4]} zoom={7} className="mapa">
      <TileLayer
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
      />
      <LocationMarker />
    </MapContainer>
  )
}

Mapa.propTypes = {
  onLocationSelect: PropTypes.func,
  pos: PropTypes.object,
}

export default Mapa
